import { apiSlice } from "../apiSlice";

export interface GetCustomerResponse {
  isAnonymousUser: boolean;
  id: string;
  userId: string;
  displayName: string;
  phoneNumber: string;
  email: string;
  photoUrl: string;
  createdAt: {
    _seconds: number;
    _nanoseconds: number;
  };
  updatedAt: {
    _seconds: number;
    _nanoseconds: number;
  };
  settings: {
    requiresOrderVerification: boolean;
  };
  addresses: {
    tag: string;
    address: string;
  }[];
}

interface UpdateProfileRequest {
  userId: string;
  customerId: string;
  displayName: string;
  phoneNumber: string;
  email: string;
  createdAt: {
    _seconds: number;
    _nanoseconds: number;
  };
  updatedAt: {
    _seconds: number;
    _nanoseconds: number;
  };
  settings: {
    requiresOrderVerification: boolean;
  };
  addresses: {
    tag: string;
    address: string;
  }[];
}

interface walletBalanceResponse {
  walletBalance: number;
}

const API_BASE_DOMAIN = process.env.REACT_APP_API_BASE_DOMAIN_PRODUCTION;
export const CustomerService = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getCustomerProfile: builder.query<GetCustomerResponse, string>({
      query: (accessToken) => ({
        url: `https://customersitehttps-getcustomerprofile-${API_BASE_DOMAIN}-uc.a.run.app`,
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      }),
    }),

    updateCustomerProfile: builder.mutation<string, UpdateProfileRequest>({
      query: (profileData) => ({
        url: `https://customersitehttps-updateprofile-${API_BASE_DOMAIN}-uc.a.run.app`,
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: profileData,
      }),
    }),

    getProfileImageUploadUrl: builder.query<{ signedUrl: string }, string>({
      query: (fileExtension) =>
        `https://customersitehttps-getprofileimageuploadurl-${API_BASE_DOMAIN}-uc.a.run.app?fileExtension=${fileExtension}`,
    }),

    updateProfileImage: builder.mutation<void, { userId: string; fileExtension: string }>({
      query: ({ userId, fileExtension }) => ({
        url: `https://customersitehttps-updateprofileimage-${API_BASE_DOMAIN}-uc.a.run.app`,
        method: "POST",
        body: {
          photoUrl: `https://storage.cloud.google.com/fooddelivery-7eac6.appspot.com/Customers/${userId}/profile-image.${fileExtension}`,
        },
      }),
    }),

    getWalletBalance: builder.query<walletBalanceResponse, string>({
      query: (customerId) => ({
        url: `https://customerhttps-getcustomerwalletbalance-${API_BASE_DOMAIN}-uc.a.run.app?customerId=${customerId}`,
        method: "GET",
      }),
    }),
  }),
});

export const {
  useGetCustomerProfileQuery,
  useLazyGetCustomerProfileQuery,
  useUpdateCustomerProfileMutation,
  useLazyGetProfileImageUploadUrlQuery,
  useUpdateProfileImageMutation,
  useGetWalletBalanceQuery,
  useLazyGetWalletBalanceQuery,
} = CustomerService;
